function toYMD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Pure function — no side effects.
 * @param {Array} shifts  ShiftResponse[] from API
 * @returns {Map} Map<"employeeId-YYYY-MM-DD", shift>
 */
export function buildShiftMap(shifts) {
  return new Map((shifts ?? []).map((s) => [`${s.employeeId}-${s.shiftDate}`, s]));
}

/**
 * Pure function — no side effects. Story 15 B1 — overlay, not mutation: expands each
 * approved-leave range into per-day keys covering the visible week, mirroring
 * buildShiftMap's keying so lookups stay O(1).
 * @param {Array} leaveEntries  approved leave entries with employeeId/startDate/endDate
 * @param {Array} weekDays  Date[] (7 items, Mon-Sun)
 * @returns {Map} Map<"employeeId-YYYY-MM-DD", leaveEntry>
 */
export function buildLeaveMap(leaveEntries, weekDays) {
  const map = new Map();
  for (const entry of leaveEntries ?? []) {
    for (const day of weekDays ?? []) {
      const ymd = toYMD(day);
      if (ymd >= entry.startDate && ymd <= entry.endDate) {
        map.set(`${entry.employeeId}-${ymd}`, entry);
      }
    }
  }
  return map;
}

/**
 * Pure function — no side effects. Story 15 B1/B2 — "needs cover" flags a published shift
 * that lost its person to a later-approved leave.
 * @param {boolean} onLeave  whether the cell's (employee, day) is in the leave map
 * @param {object|null} shift  the shift at that cell, if any
 * @returns {boolean}
 */
export function isNeedsCover(onLeave, shift) {
  return Boolean(onLeave && shift && !shift.isOff);
}
